var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'sidebar-open': _vm.sidebar.open,
    [`${this.$route.name}-page`]: true
  },attrs:{"id":"app"}},[_c('transition',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('nprogress-container'),_c('PreLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }